import Layout from "../components/layout/Layout"
import NewsDetailsSection1 from "../components/sections/NewsDetailsSection1"
export default function BlogDetails2() {
	return (
		<>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="WPC vs. Wooden Doors - What Should You Choose?">
				<NewsDetailsSection1 />
			</Layout>
		</>
	)
}